// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"77":"46881bfe","125":"b9604962","353":"0ffb3890","511":"980d9954"}[chunkId] + ".chunk.js";
};